var map = {
	"./advisor_reported.svg": 68673,
	"./anchorage.svg": 42305,
	"./coinbase.svg": 9855,
	"./coinbaseprime.svg": 79104,
	"./gemini.svg": 22014,
	"./primetrust.svg": 30210,
	"./securitize.svg": 97714,
	"./tpm.svg": 95096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2867;